import React from 'react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login');
  };

  return (
    <div style={styles.page}>
      <div style={styles.topBar}>
        <div style={styles.innerContainer}>
          <div style={styles.logo}>Dashboard</div>
          <div style={styles.navLinks}>
          <button onClick={() => navigate('/upload')} style={styles.navButton}>
                Upload Documents
            </button>
            <button onClick={() => navigate('/missmatchedreport')} style={styles.navButton}>
              Get Mismatched Invoices
            </button>
            <button onClick={() => navigate('/report')} style={styles.navButton}>
              Get Invoice Details
              </button>

              <button onClick={() => navigate('/summarypage')} style={styles.navButton}>
              Get Summary
            </button>
          </div>
          <button onClick={handleLogout} style={styles.logoutButton}>Logout</button>
        </div>
      </div>


      <div style={styles.content}>
        <h2>Welcome to Dashboard</h2>
        <p>Select an option above to proceed.</p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    fontFamily: 'Segoe UI, sans-serif',
    backgroundColor: '#f8f9fa',
    height: '100vh',
    margin: 0
  },
  topBar: {
    backgroundColor: '#343a40',
    color: 'white',
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    zIndex: 1000
  },
  innerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px'
  },
  logo: {
    fontSize: '20px',
    fontWeight: 'bold'
  },
  navLinks: {
    display: 'flex',
    gap: '15px'
  },
  navButton: {
    backgroundColor: '#6c757d',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 500,
    transition: 'background-color 0.3s ease',
  },
  logoutButton: {
    backgroundColor: '#dc3545',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontWeight: 500,
    transition: 'background-color 0.3s ease',
  },
  content: {
    marginTop: '80px',
    padding: '40px',
    textAlign: 'center'
  }
};

export default Dashboard;
